<div [innerHTML]="content.html | safeHtml"></div>